export default __webpack_public_path__ + "static/media/Nioicon.1fba761e.svg";